import React, { useState } from "react";
import { Box, FormHelperText, InputAdornment, IconButton, makeStyles } from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import EventIcon from "@material-ui/icons/Event";
import MomentUtils from "@date-io/moment";
import moment from "moment";

const MAX_MONTHS = 36;

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  separator: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    padding: "0 4px",
  },
  picker: {
    minWidth: 110,
    maxWidth: 140
  },
}));

export default function MonthRangePicker({ startMonth, endMonth, onChange }) {
  const classes = useStyles();
  const [helper, setHelper] = useState("");

  const setStart = (m) => {
    if (!m) return;
    const start = m.clone().startOf("month");
    let end = moment(endMonth, "YYYY-MM-DD").startOf("month");
    if (end.isBefore(start)) end = start.clone();
    if (end.diff(start, "months") > MAX_MONTHS) {
      end = start.clone().add(MAX_MONTHS, "months");
      setHelper("Range cannot exceed 3 years");
    } else {
      setHelper("");
    }
    onChange({
      startMonth: start.format("YYYY-MM-DD"),
      endMonth: end.format("YYYY-MM-DD"),
    });
  };

  const setEnd = (m) => {
    if (!m) return;
    const start = moment(startMonth, "YYYY-MM-DD").startOf("month");
    let end = m.clone().startOf("month");
    if (end.isBefore(start)) end = start.clone();
    if (end.diff(start, "months") > MAX_MONTHS) {
      end = start.clone().add(MAX_MONTHS, "months");
      setHelper("Range cannot exceed 3 years");
    } else {
      setHelper("");
    }
    onChange({ endMonth: end.format("YYYY-MM-DD") });
  };

  const calendarAdornment = (
    <InputAdornment position="end">
      <IconButton size="small" tabIndex={-1}>
        <EventIcon fontSize="small" />
      </IconButton>
    </InputAdornment>
  );

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Box>
        <Box className={classes.row}>
          <DatePicker
            views={["year", "month"]}
            inputVariant="outlined"
            size="small"
            className={classes.picker}
            value={moment(startMonth, "YYYY-MM-DD")}
            onChange={setStart}
            minDate={moment().startOf("month")}
            maxDate={moment().add(3, "years")}
            format="MMMM YYYY"
            InputProps={{ endAdornment: calendarAdornment }}
          />
          <span className={classes.separator}>to</span>
          <DatePicker
            views={["year", "month"]}
            inputVariant="outlined"
            size="small"
            className={classes.picker}
            value={moment(endMonth, "YYYY-MM-DD")}
            onChange={setEnd}
            minDate={moment().startOf("month")}
            maxDate={moment().add(3, "years")}
            format="MMMM YYYY"
            InputProps={{ endAdornment: calendarAdornment }}
          />
        </Box>
        {helper && (
          <FormHelperText error style={{ marginLeft: 8 }}>
            {helper}
          </FormHelperText>
        )}
      </Box>
    </MuiPickersUtilsProvider>
  );
}
